import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 0;

  & > span {
    flex-grow: 2;
    margin-left: 18px;
    color: ${props => props.theme.bodyColor};
    font: ${props => props.theme.fontWeightRegular} 17px/17px ${props => props.theme.fontFamilyBody};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow-x: hidden;
  }
`;

const Img = styled.img`
  border-radius: 4px;
  border: 2px solid white;
  width: 32px;
  height: 32px;
  filter: drop-shadow(0px 4px 4px rgba(50, 50, 71, 0.08));
`;

export default function Contributor({
  name, profilePictureUrl, isDefault, isCompanyProfile, organization,
}) {
  const src = profilePictureUrl || window.getLivewireAssetPath('avatar-fallback.png');
  const nameToShow = isCompanyProfile && !!organization ? organization : name;

  return (
    <Container>
      <Img src={src} alt={nameToShow} />
      <span>{`${nameToShow}${isDefault ? ' (Default)' : ''}`}</span>
    </Container>
  );
}

Contributor.propTypes = {
  name: PropTypes.string.isRequired,
  profilePictureUrl: PropTypes.string,
  isDefault: PropTypes.bool.isRequired,
  isCompanyProfile: PropTypes.bool,
  organization: PropTypes.string,
};

Contributor.defaultProps = {
  profilePictureUrl: null,
  isCompanyProfile: false,
  organization: null,
};
